import { Divider, LinearProgress, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from '../../store'
import { makeStyles } from 'tss-react/mui'
import clsx from 'clsx'

const maxHeaderHeight = '31px'

const useStyles = makeStyles()(theme => ({
  appTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2.5, 4, 2.5, 4),
    alignItems: 'center',
    maxHeight: maxHeaderHeight,
    lineHeight: '0.8px',
  },
  appTitleHeading: {
    color: theme.palette.headerTitle.main,
    display: 'flex',
    flexDirection: 'row',
  },
  appTitleIcon: {
    marginRight: theme.spacing(1.12),
    color: theme.palette.icon.main,
  },
  appTitleHeadingText: {
    textAlign: 'left',
    fontWeight: 600,
  },
  appTitleActions: {},
  divider: {
    backgroundColor: theme.palette.dividers.main,
    borderColor: theme.palette.dividers.main,
  },
  titleHeader: {
    position: 'relative',
    zIndex: 999,
    width: '100%',
    backgroundColor: theme.palette.common.white,
  },
  stickyContainer: {
    position: 'sticky',
  },
  fixedContainer: {
    zIndex: 999,
    height: 0,
    width: '100%',
  },
  sticky: {
    position: 'fixed',
    top: 0,
    width: '100%',
  },
}))

type HeaderWrapperProps = {
  title?: string
  titleIcon?: React.ReactNode
  actions?: React.FC
  pageYOffset?: number
  hideTitle?: boolean
}

export const ExternalAppHeaderWrapper: React.FC<HeaderWrapperProps> = ({
  title,
  actions: Actions,
  titleIcon,
  pageYOffset = 0,
  hideTitle = false,
}) => {
  const [isSticky, setIsSticky] = useState(false)
  const titleHeaderEl = useRef<HTMLDivElement>(null)
  const loading = useSelector<boolean>(state =>
    Object.values(state.loading).some((count: number) => count > 0)
  )
  useEffect(() => {
    if (titleHeaderEl && titleHeaderEl.current) {
      const offsetTopElement = titleHeaderEl.current.offsetTop

      if (pageYOffset > offsetTopElement) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }
  }, [titleHeaderEl, pageYOffset])

  const { classes } = useStyles()
  return (
    <>
      {!hideTitle && (
        <div
          className={clsx(classes.titleHeader, classes.stickyContainer)}
          data-testid="title-actions"
        >
          <div className={classes.appTitle}>
            <div className={classes.appTitleHeading}>
              {title ? (
                <>
                  <div className={classes.appTitleIcon}>{titleIcon}</div>
                  <Typography
                    variant="h1"
                    data-testid="heading"
                    className={classes.appTitleHeadingText}
                  >
                    {title}
                  </Typography>
                </>
              ) : null}
            </div>
            <div data-testid="actions" className={classes.appTitleActions}>
              {Actions ? <Actions /> : null}
            </div>
          </div>
          <Divider className={classes.divider} />
        </div>
      )}
      <div
        className={
          isSticky
            ? clsx(classes.titleHeader, classes.sticky)
            : classes.fixedContainer
        }
        ref={titleHeaderEl}
      >
        {loading && <LinearProgress />}
      </div>
    </>
  )
}
